/** @format */

import React from 'react';
import { findDOMNode } from 'react-dom';
//import PropTypes from 'prop-types';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
  header: {
    marginBottom: '0.5em',
    textAlign: 'left',
    backgroundColor: '#24242E',
    position: 'relative',
    left: '-1em',
    width: 'calc(100% + 2em)',
    padding: '8px 16px 16px 16px',
    height: '56px',
  },
  dayweek: {
    display: 'flex',
    width: '100%',
    paddingTop: '10px',
    justifyContent: 'space-between',
  },
  dayweekItem: {
    fontSize: '12px',
    textAlign: 'center',
    color: '#FFF',
    width: '24px',
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  monthSelect: {},
  prevNext: {
    color: '#FFF',
    fontSize: '14px',
    fontWeight: 'bold',
    paddingRight: '7px',
    '& a': {
      paddingLeft: '16px',
      cursor: 'pointer',
    },
  },
});

class DatePickerHeader extends React.Component {
  static propTypes = {};

  componentWillMount() {
    document.addEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, false);
  }

  handleOutsideClick = e => {
    const pickerEl = findDOMNode(this.props.pickerRef);
    if (!pickerEl.contains(e.target)) {
      this.props.pickerRef.hideDayPicker();
    }
  };

  handleChange = event => {
    const { year, month } = event.target.form;
    this.props.onChange(new Date(year.value, month.value));
  };

  render() {
    const { date, localeUtils, classes, pickerRef, from, to, defaultYear, value } = this.props;
    const months = localeUtils.getMonths();

    const currentYear = new Date().getFullYear();
    const fromMonth = new Date(currentYear, 0);
    const toMonth = new Date(currentYear + 5, 11);

    const years = [];
    if (from && from !== '' && to && to !== '') {
      if (value !== '' && new Date(value).getFullYear() > new Date(to, 0, 1).getFullYear()) {
        for (let i = parseInt(from, 10); i <= parseInt(new Date(value).getFullYear(), 10); i += 1) {
          years.push(i);
        }
      } else if (value === '' && defaultYear !== '' && new Date(defaultYear, 0, 1).getFullYear() > new Date(to, 0, 1).getFullYear()) {
        for (let i = parseInt(from, 10); i <= parseInt(new Date(defaultYear, 0, 1).getFullYear(), 10); i += 1) {
          years.push(i);
        }
      } else {
        for (let i = parseInt(from, 10); i <= parseInt(to, 10); i += 1) {
          years.push(i);
        }
      }
    } else {
      for (let i = fromMonth.getFullYear() - 20; i <= toMonth.getFullYear(); i += 1) {
        years.push(i);
      }
    }

    return (
      <form className={classes.header}>
        <div className={classes.actionBar}>
          <div className={classes.monthSelect}>
            <select name="month" onChange={this.handleChange} value={date.getMonth()}>
              {months.map((month, i) => (
                <option key={month} value={i}>
                  {month}
                </option>
              ))}
            </select>
            <select name="year" onChange={this.handleChange} value={date.getFullYear()}>
              {years.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className={classes.prevNext}>
            <a onClick={() => pickerRef.daypicker.showPreviousMonth()}>&lt;</a>
            <a onClick={() => pickerRef.daypicker.showNextMonth()}>&gt;</a>
          </div>
        </div>

        <div className={classes.dayweek}>
          <div className={classes.dayweekItem}>S</div>
          <div className={classes.dayweekItem}>M</div>
          <div className={classes.dayweekItem}>T</div>
          <div className={classes.dayweekItem}>W</div>
          <div className={classes.dayweekItem}>T</div>
          <div className={classes.dayweekItem}>F</div>
          <div className={classes.dayweekItem}>S</div>
        </div>
      </form>
    );
  }
}

export default styled(DatePickerHeader)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/DatePicker/DatePickerHeader.js